export const ebuiltData = [
  {
    id: 'zoom-1',
    panelTitle: 'ENERGY STAR® Frigidaire® Appliances',
    panelBody:
      'Stainless appliances deliver style, performance and energy savings',
  },
  {
    id: 'zoom-2',
    panelTitle: 'Rheem® Hybrid Water Heater',
    panelBody:
      'Uses as much energy in one year as a 100-watt incandescent light bulb <small><sup>2</sup></small>',
  },
  {
    id: 'zoom-3',
    panelTitle: 'Pfister® Bathroom Fixtures',
    panelBody: 'Beautiful faucets for enhanced bathroom style',
  },
  {
    id: 'zoom-4',
    panelTitle: 'Additional Insulation',
    panelBody: 'Added to the roof, walls and floors for added comfort',
  },
  {
    id: 'zoom-5',
    panelTitle: 'SmartComfort® by Carrier® HVAC Heat Pump or Gas Furnace',
    panelBody:
      'Energy-efficient, reliable heating and cooling for year-round comfort',
  },
  {
    id: 'zoom-6',
    panelTitle: 'ecobee® Smart Thermostat',
    panelBody:
      'Programmable features save you money at home or while away through the app <small><sup>4</sup></small>',
  },
  {
    id: 'zoom-7',
    panelTitle: 'LED Lighting',
    panelBody:
      'Uses up to 90% less energy and lasts 25 times longer than incandescent bulbs <small><sup>3</sup></small>',
  },
  {
    id: 'zoom-8',
    panelTitle: 'Argon Gas Low-E Windows',
    panelBody: 'Reduce heat loss in cold months and block harmful UV rays',
  },
  {
    id: 'zoom-9',
    panelTitle: 'Solar-Ready',
    panelBody: 'Add a renewable energy system for even more savings',
  },
  {
    id: 'zoom-10',
    panelTitle: 'Insulated Doors',
    panelBody: 'Prevent drafts and unwanted outside noise',
  },
  {
    id: 'zoom-11',
    panelTitle: 'Tight Thermal Envelope',
    panelBody:
      'Sealed duct system reduces drafts and increases energy efficiency',
  },
];
